import { inject } from "../../di";
import type { CoPromotionCreator, IWritableCoPromotionSearchState, ICoPromotionSearchService } from "./types";
import type { IRpcService } from "../rpc/types";

export class CoPromotionSearchService implements ICoPromotionSearchService {
  @inject<IWritableCoPromotionSearchState>("writableCoPromotionSearchState")
  private state!: IWritableCoPromotionSearchState;

  @inject<IRpcService>("rpcService")
  private rpcService!: IRpcService;

  private requestId = 0;

  search(query: string): void {
    if (!query.trim()) {
      this.loadSuggested();
      return;
    }

    this.state.loading.set(true);
    this.doSearch(query);
  }

  loadSuggested(): void {
    this.state.loading.set(true);
    this.doSearch();
  }

  private async doSearch(query?: string): Promise<void> {
    const currentRequestId = ++this.requestId;
    try {
      const params = query ? { query } : {};
      const result = await this.rpcService.call<{ creators: CoPromotionCreator[] }>(
        "search-creator-for-co-promotion",
        params,
      );
      if (currentRequestId !== this.requestId) return;
      this.state.creators.set(result.creators);
    } catch (error) {
      if (currentRequestId !== this.requestId) return;
      console.error("[CoPromotionSearchService] Error searching creators:", error);
      this.state.creators.set([]);
    } finally {
      if (currentRequestId === this.requestId) {
        this.state.loading.set(false);
      }
    }
  }

  clear(): void {
    this.requestId++;
    this.state.creators.set([]);
    this.state.loading.set(false);
  }
}
